import React, { useState, useEffect } from "react";
import axios from "axios";

const API_BASE_URL = "https://chemplastemployeetrainingtest.azurewebsites.net"; // Flask API
const FILE_UPLOAD_URL = "http://10.1.11.134:5000/upload"; // Windows Server API

const EditPage = () => {
  const [name, setName] = useState("");
  const [partNumber, setPartNumber] = useState("");
  const [proficiency, setProficiency] = useState("");
  const [shift, setShift] = useState(""); // Shift state
  const [selectedFile, setSelectedFile] = useState(null);
  const [filePath, setFilePath] = useState(""); // Store uploaded file path

  // Autocomplete state
  const [nameSuggestions, setNameSuggestions] = useState([]);
  const [partSuggestions, setPartSuggestions] = useState([]);

  // Fetch matching employee names
  useEffect(() => {
    if (name.length > 1) {
      axios.get(`${API_BASE_URL}/autocomplete/employees?q=${name}`)
        .then((response) => setNameSuggestions(response.data))
        .catch((error) => console.error("Error fetching employee names:", error));
    } else {
      setNameSuggestions([]);
    }
  }, [name]);

  // Fetch matching part numbers
  useEffect(() => {
    if (partNumber.length > 1) {
      axios.get(`${API_BASE_URL}/autocomplete/parts?q=${partNumber}`)
        .then((response) => setPartSuggestions(response.data))
        .catch((error) => console.error("Error fetching part numbers:", error));
    } else {
      setPartSuggestions([]);
    }
  }, [partNumber]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate shift selection
    if (!shift) {
      alert("Please select a shift.");
      return;
    }

    // Upload file first (if selected)
    let uploadedFilePath = "";
    if (selectedFile) {
      const formData = new FormData();
      formData.append("file", selectedFile);
      formData.append("name", name);
      formData.append("shift", shift);

      try {
        const response = await axios.post(FILE_UPLOAD_URL, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        uploadedFilePath = response.data.file_path; // Store file path from backend
        setFilePath(uploadedFilePath);
      } catch (error) {
        console.error("File upload failed:", error);
        alert("Failed to upload file.");
        return;
      }
    }

    // Send form data to update the employee training record
    try {
      await axios.post(`${API_BASE_URL}/update`, { 
        name, 
        partNumber, 
        proficiency, 
        shift, 
        filePath: uploadedFilePath // Send file path
      });
      alert("Training record updated successfully!");
    } catch (error) {
      console.error("Error updating:", error);
      alert("Failed to update record.");
    }
  };

  return (
    <div className="container">
      <h2>Edit/Add Training Record</h2>
      <form onSubmit={handleSubmit} autoComplete="off">

        {/* Employee Name Input with Autocomplete */}
        <div className="position-relative">
          <input 
            type="text" 
            className="form-control mb-2" 
            placeholder="Employee Name" 
            value={name} 
            onChange={(e) => setName(e.target.value)}
            onBlur={() => setTimeout(() => setNameSuggestions([]), 200)} 
            required 
          />
          {nameSuggestions.length > 0 && (
            <ul className="list-group position-absolute w-100 shadow bg-white" style={{ zIndex: 10 }}>
              {nameSuggestions.map((suggestion, index) => (
                <li 
                  key={index} 
                  className="list-group-item list-group-item-action" 
                  onClick={() => {
                    setName(suggestion);
                    setNameSuggestions([]);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  {suggestion}
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* Part Number Input with Autocomplete */}
        <div className="position-relative">
          <input 
            type="text" 
            className="form-control mb-2" 
            placeholder="Part Number" 
            value={partNumber} 
            onChange={(e) => setPartNumber(e.target.value)} 
            onBlur={() => setTimeout(() => setPartSuggestions([]), 200)} 
            required 
          />
          {partSuggestions.length > 0 && (
            <ul className="list-group position-absolute w-100 shadow bg-white" style={{ zIndex: 10 }}>
              {partSuggestions.map((suggestion, index) => (
                <li 
                  key={index} 
                  className="list-group-item list-group-item-action" 
                  onClick={() => {
                    setPartNumber(suggestion);
                    setPartSuggestions([]);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  {suggestion}
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* Shift Selection Dropdown */}
        <select className="form-control mb-2" value={shift} onChange={(e) => setShift(e.target.value)} required>
          <option value="">Select Shift</option>
          <option value="1">Day Shift (1)</option>
          <option value="2">Night Shift (2)</option>
        </select>

        {/* Proficiency Input */}
        <input 
          type="number" 
          className="form-control mb-2" 
          placeholder="Proficiency (0.5 - 4)" 
          step="0.5" min="0" max="4" 
          value={proficiency}
          onChange={(e) => setProficiency(e.target.value)} 
          required 
        />

        {/* File Upload Input */}
        <input type="file" className="form-control mb-2" onChange={(e) => setSelectedFile(e.target.files[0])} />

        <button type="submit" className="btn btn-success">Save</button>
      </form>
    </div>
  );
};

export default EditPage;
